"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateKnowledge = void 0;
var CreatedEdgeImpulse_1 = require("./CreatedEdgeImpulse");
var CreatedCodeImpulse_1 = require("./CreatedCodeImpulse");
var CreatedPromptImpulse_1 = require("./CreatedPromptImpulse");
var CreatedIntentImpulse_1 = require("./CreatedIntentImpulse");
var CreatedSkillImpulse_1 = require("./CreatedSkillImpulse");
var CreatedFulfilmentImpulse_1 = require("./CreatedFulfilmentImpulse");
var CreatedUserImpulse_1 = require("./CreatedUserImpulse");
var CreatedSkillProvisionImpulse_1 = require("./CreatedSkillProvisionImpulse");
var CreatedTenantImpulse_1 = require("./CreatedTenantImpulse");
var CreatedStatementImpulse_1 = require("./CreatedStatementImpulse");
var CreatedRoleImpulse_1 = require("./CreatedRoleImpulse");
var CreatedBehaviourImpulse_1 = require("./CreatedBehaviourImpulse");
var CreatedIdentityImpulse_1 = require("./CreatedIdentityImpulse");
var CreatedApiKeyImpulse_1 = require("./CreatedApiKeyImpulse");
var CreateKnowledge = /** @class */ (function (_super) {
    __extends(CreateKnowledge, _super);
    function CreateKnowledge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "CreateKnowledge";
        /**
         * creates a list of identities with the given specifications
         */
        _this.identities = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new CreatedIdentityImpulse_1.CreatedIdentityImpulse();
            config(entity);
            return "identities(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * creates a list of tenants with the given specifications
         */
        _this.tenants = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new CreatedTenantImpulse_1.CreatedTenantImpulse();
            config(entity);
            return "tenants(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * creates a list of users with the given specifications
         */
        _this.users = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new CreatedUserImpulse_1.CreatedUserImpulse();
            config(entity);
            return "users(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * creates a list of api keys with the given specifications
         */
        _this.apiKeys = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new CreatedApiKeyImpulse_1.CreatedApiKeyImpulse();
            config(entity);
            return "apiKeys(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * creates a list of roles with the given specifications
         */
        _this.roles = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new CreatedRoleImpulse_1.CreatedRoleImpulse();
            config(entity);
            return "roles(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * creates a list of intents with the given specifications
         */
        _this.intents = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new CreatedIntentImpulse_1.CreatedIntentImpulse();
            config(entity);
            return "intents(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * creates a list of prompts with the given specifications
         */
        _this.prompts = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new CreatedPromptImpulse_1.CreatedPromptImpulse();
            config(entity);
            return "prompts(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * creates a list of statements with the given specifications
         */
        _this.statements = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new CreatedStatementImpulse_1.CreatedStatementImpulse();
            config(entity);
            return "statements(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * creates a list of fulfilments with the given specifications
         */
        _this.fulfilments = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new CreatedFulfilmentImpulse_1.CreatedFulfilmentImpulse();
            config(entity);
            return "fulfilments(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * creates a list of behaviours with the given specifications
         */
        _this.behaviours = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new CreatedBehaviourImpulse_1.CreatedBehaviourImpulse();
            config(entity);
            return "behaviours(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * creates a list of codes with the given specifications
         */
        _this.codes = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new CreatedCodeImpulse_1.CreatedCodeImpulse();
            config(entity);
            return "codes(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * creates a list of edges with the given specifications
         */
        _this.edges = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new CreatedEdgeImpulse_1.CreatedEdgeImpulse();
            config(entity);
            return "edges(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * creates a list of skills with the given specifications
         */
        _this.skills = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new CreatedSkillImpulse_1.CreatedSkillImpulse();
            config(entity);
            return "skills(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * creates a list of skill provisions with the given specifications
         */
        _this.skillProvisions = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new CreatedSkillProvisionImpulse_1.CreatedSkillProvisionImpulse();
            config(entity);
            return "skillProvisions(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return CreateKnowledge;
}(Array));
exports.CreateKnowledge = CreateKnowledge;
//# sourceMappingURL=CreateKnowledge.js.map